module.exports = __webpack_public_path__ + "img/top-nfts.72a406c1.svg";